var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1ConsumptionWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 38v4H56v4H41v-8h32zm-45-2h4V21.09l-2-2.17-2 2.17V36zM7 17.46L27.52 4.73 48 17.46V33h4V15.24L27.52 0 3 15.24V46h32v-4H7V17.46zM21 36h4V25.09l-2-2.17-2 2.17V36zm-7 0h4v-5.91l-2-2.17-2 2.17V36zm27 40h15V56h10v3h7v-9H41v26zm-6-58.91V36h4V17.09l-2-2.17-2 2.17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Consumption_water.6c53fbab.svg";
export { SvgB1ConsumptionWater as ReactComponent };